import { render, staticRenderFns } from "./SlideExpiredCrew.vue?vue&type=template&id=306e5eb0"
import script from "./SlideExpiredCrew.vue?vue&type=script&lang=js"
export * from "./SlideExpiredCrew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports